'use client'

import * as React from 'react'

import type { Order } from '@/gen/ecom'

export const OrderContext = React.createContext<OrderContextProps>({
  readOrder: () => null,
  saveOrder: () => null,
})

interface OrderContextProps {
  readOrder: (orderId: string) => Order | null
  saveOrder: (order: Order) => void
}

const OrderContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const saveOrder = (order: Order) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('order', JSON.stringify(order))
    }
  }

  const readOrder = (orderId: string) => {
    if (typeof window !== 'undefined') {
      const orderJSON = localStorage.getItem('order')
      if (orderJSON) {
        const order = JSON.parse(orderJSON) as Order

        return order.code === orderId ? order : null
      }
    }

    return null
  }

  return <OrderContext.Provider value={{ readOrder, saveOrder }}>{children}</OrderContext.Provider>
}

export default OrderContextProvider
